import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NoContentBox } from 'components/basic'

const errors = {
  401: {
    title: 'Unauthorized',
    icon: 'eye-slash',
    message: 'You are not authorized to view this page.'
  },
  404: {
    title: '404',
    icon: 'exclamation',
    message: 'This page could not be found, error 404.'
  },
  500: {
    title: '500',
    icon: 'cogs',
    message: 'Something went wrong, try again.'
  }
}
class Error extends Component {
  constructor (props) {
    super(props)
    var code = this.props.code
    if (!errors.hasOwnProperty(code)) code = 500
    this.state = {
      code: code
    }
    props.dispatch({ type: 'SET_PAGE_TITLE', payload: errors[code].title })
  }

  render () {
    return (
      <div className='content-wrapper flexbox-absolute-center'>
        <NoContentBox icon={errors[this.state.code].icon} text={errors[this.state.code].message} />
      </div>
    )
  }
}

// eslint-disable-next-line
Error = connect(state => state.siteReducer)(Error)
export default Error



// WEBPACK FOOTER //
// ./src/views/core/error.js